export enum InvoicePeriodizationOffsetDirection {
    ADD = '+',
    SUBTRACT = '-',
}
